import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        d: "m12 1c-6.07513 0-11 4.92487-11 11 0 6.0751 4.92487 11 11 11 6.0751 0 11-4.9249 11-11 0-6.07513-4.9249-11-11-11zm5.2071 8.70711c.3905-.39053.3905-1.02369 0-1.41422-.3905-.39052-1.0237-.39052-1.4142 0l-5.2929 5.29291-2.29289-2.2929c-.39053-.3905-1.02369-.3905-1.41422 0-.39052.3905-.39052 1.0237 0 1.4142l3 3c.39051.3905 1.02371.3905 1.41421 0z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "m17.2071 8.29289c.3905.39053.3905 1.02369 0 1.41422l-6 5.99999c-.3905.3905-1.0237.3905-1.41421 0l-3-3c-.39052-.3905-.39052-1.0237 0-1.4142.39053-.3905 1.02369-.3905 1.41422 0l2.29289 2.2929 5.2929-5.29291c.3905-.39052 1.0237-.39052 1.4142 0z",
        fill: "#fff"
      })
    ], -1)
  ])))
}
export default { render: render }